import { __rest, __read, __assign } from '../../node_modules/tslib/tslib.es6.esm.js';
import React__default from 'react';
import { useDropdownToggle } from '@restart/ui';

var DropdownToggle = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    var _b = __read(useDropdownToggle(), 2), toggleProps = _b[0], show = _b[1].show;
    var childrenIsCallable = children instanceof Function;
    return (React__default.createElement("div", __assign({}, props, toggleProps, { className: "nv-contextual-menu-toggle" }), childrenIsCallable ? children(show) : children));
};

export { DropdownToggle as default };
//# sourceMappingURL=DropdownToggle.esm.js.map
